/**
 * @desc 产品BOM-详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductBomResponseDto>;
export function request(bomno: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productBom/details/${bomno}`, {
      method: "GET",

      ...options,
    }),
  );
}
